import {
  AsymetryVariableThresholds,
  AsymetryVariableThresholdsClass,
} from './asymetry-variable-thresholds.model';

export interface BodyThresholds {
  head: AsymetryVariableThresholds;
  hind: AsymetryVariableThresholds;
  withers: AsymetryVariableThresholds;
  ears?: AsymetryVariableThresholds;
}

export class BodyThresholdsClass implements BodyThresholds {
  head: AsymetryVariableThresholds;
  hind: AsymetryVariableThresholds;
  withers: AsymetryVariableThresholds;
  ears?: AsymetryVariableThresholds;

  constructor(o: any = {}) {
    this.head = new AsymetryVariableThresholdsClass(o['head']);
    this.hind = new AsymetryVariableThresholdsClass(o['hind']);
    this.withers = new AsymetryVariableThresholdsClass(o['withers']);
  }
}

export interface AsymmetryScalingThresholds {
  meanExtremesDiffScaled: BodyThresholds;
  horseRelativeScaled: BodyThresholds;
}

export class AsymmetryScalingThresholdsClass
  implements AsymmetryScalingThresholds
{
  meanExtremesDiffScaled: BodyThresholds;
  horseRelativeScaled: BodyThresholds;

  constructor(o: any = {}) {
    this.meanExtremesDiffScaled = new BodyThresholdsClass(
      o['meanExtremesDiffScaled']
    );
    this.horseRelativeScaled = new BodyThresholdsClass(
      o['horseRelativeScaled']
    );
  }
}
